import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import * as S from "./styled.js";
const AddRoom = ({ addRoom , hasError =false , onAddRoom , height ='32px'  })=>/*#__PURE__*/ _jsx(S.AddRoomButton, {
        "data-testid": "AddRoom",
        className: classNames({
            'has-error': hasError
        }),
        onClick: onAddRoom,
        p: "0",
        size: "small",
        height: height,
        children: addRoom
    });
export default AddRoom;

//# sourceMappingURL=index.js.map